module.exports = __webpack_public_path__ + "static/media/image_not_found.2e0dc9b5.jpg";